import { render, staticRenderFns } from "./exchange-product-list.vue?vue&type=template&id=03b16b58"
import script from "./exchange-product-list.vue?vue&type=script&lang=ts"
export * from "./exchange-product-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports